import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyService } from '../../services/company.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-company-join-request',
  templateUrl: './company-join-request.component.html',
  styleUrls: ['./company-join-request.component.scss']
})
export class CompanyJoinRequestComponent implements OnInit {
  userData: any = {};
  hasActiveCompanies = false;
  userRoles= [];
  usersCurrentCompanies = [];
  userRequestedCompanies: any = {};
  constructor(public route: ActivatedRoute, private _companyService: CompanyService, private router: Router, private _toastrService: ToastrService ) { }

  ngOnInit(): void {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');

    // Redirect if no token or role isn't '3' (Admin)
    if (!token || role !== '3') {
      this._toastrService.error('Please login as admin');  // Show error message
      this.router.navigateByUrl('/login');
      return;  // Ensure no further logic executes
    }
    let val_token = this.route.snapshot.paramMap.get("token");
    console.log(val_token);
    if (val_token != null) {
      this._companyService.getTokenInfo(val_token).subscribe((data) => {
        if(!data.result){
          this._toastrService.error('already reviewed');  // Show error message
          this.router.navigateByUrl('/login');
          return;
        } 
        this.userData = data.result;;
        for (let i = 0; i < data.result?.userId?.company.length; i++) {
          const element = data.result.userId.company[i];
          if (element.active != false && element.company._id == data.result?.companyId?._id) {
            this.userRequestedCompanies = element;
          }
          else if(element.active != false) {
            this.usersCurrentCompanies.push(element);
          }
        }
      }, (error) => { console.log(error); });
    };
    this._companyService.getUserRoles.subscribe((roles) => {
      this.userRoles = roles;
    })
  }
  checkForActiveCompanies(): boolean {
    return this.userData?.userId?.company.some(c => c.active);
  }
  getRoleDescription(roleId: number): string {
    const role = this.userRoles.find(r => r.roleId === roleId);
    return role ? role.roleDescription : 'Unknown Role';
  }
  rejectRequest(){
    this._companyService.rejectCompanyJoinRequest(this.userData.token).subscribe((data) => {
      console.log(data);
      this.router.navigateByUrl('/login');
    }, (error) => { 
      console.log(error);
     });
  }
  approveRequest(){
    this._companyService.approveCompanyJoinRequest(this.userData.token).subscribe((data) => {
      console.log(data);
      this.router.navigateByUrl('/login');
    }, (error) => { 
      console.log(error); 
    });
  }
}
